import React from "react";
import "./index.scss";
import ross from "../../../Assets/Images/ross.svg";
import dwnArrow from "../../../Assets/Icons/arr-dwn.svg";
import mobileNav from "../../../Assets/Icons/mobile-nav-menu.svg";
import logo from "../../../Assets/Icons/logo_text.svg";
import Paragraph from "antd/es/typography/Paragraph";
import ProfilePopOverContent from "./ProfilePopoverContent";
import { Grid, Popover } from "antd";
import Notifications from "../../../Components/Notifications";

const TopBar = () => {
  const username = localStorage.getItem("userName");
  const { useBreakpoint } = Grid;
  const { md } = useBreakpoint();
  const isMobile = md === false;

  return (
    <div className={`top-bar-container ${isMobile ? "mobile-top" : ""}`}>
      {isMobile && (
        <div className="mobile-logo-container">
          <img src={logo} width="133px" alt="logo" />
        </div>
      )}
      <div className="top-bar-actions">
        <Notifications />
        {isMobile ? (
          <Popover
            content={<ProfilePopOverContent />}
            trigger="click"
            className="cursor"
          >
            <img src={mobileNav} className="avatar" alt="menu" width="42px" />
          </Popover>
        ) : (
          <Popover
            content={<ProfilePopOverContent />}
            trigger="click"
            className="cursor"
          >
            <div className="nav-profile-container">
              <div className="profile-pic-wrapper">
                <img src={ross} className="avatar" alt="avatar" />
              </div>
              <Paragraph className="reset-margin">{username}</Paragraph>
              <img src={dwnArrow} alt="down-arrow" width="36px" />
            </div>
          </Popover>
        )}
      </div>
    </div>
  );
};

export default TopBar;
